import React, { useContext, useRef } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getMediaLogo } from '../../utils/file';
import { useTranslation } from 'react-i18next';
import { Pagination } from 'swiper/modules';
import { CampaignContext } from '../../contexts/CampaignContext';
import usePlatformCardColors from '../../hooks/usePlatformCardColors';
import imgPlaceholder from '../../assets/image-placeholder.svg';

interface InstagramPostProps {
	staticContent?: boolean;
	multiple?: boolean;
	previewImage?: boolean;
	type: string;
	file: any | any[];
	caption?: string;
	dataType?: string;
}

const InstagramSerialStory: React.FC<InstagramPostProps> = ({ file, type, dataType, multiple = true, previewImage = false, caption = '' }) => {
	const swiperRef = useRef<any>(null);
	const { selectedContentType, selectedPlatform } = useContext(CampaignContext);
	const { borderColorClass } = usePlatformCardColors(selectedPlatform!);
	const { t } = useTranslation();
	return (
		<Box className={`relative rounded-2xl border ${borderColorClass}`}>
			<Box className="flex items-center justify-between px-3 py-2">
				<Typography className="text-base font-medium text-grey-900">{selectedContentType ? t(selectedContentType) : t('post')}</Typography>
				<Divider className={`mx-2 grow border ${borderColorClass}`} />
				<img src={getMediaLogo(selectedPlatform!)} alt={`${t(selectedPlatform!)} logo`} className="mb-1 h-8 w-8" />
			</Box>
			{caption !== '' && (
				<div className="absolute bottom-10 z-20 flex w-full justify-center">
					<p className="break-words rounded-md bg-white p-2">{t(caption)}</p>
				</div>
			)}
			{multiple && <Divider className={`border-1 ${borderColorClass}`} />}
			<div className="relative">
				{/* need component */}
				{!file && <img src={imgPlaceholder} className={`h-80 w-full rounded-b-2xl object-cover`} alt="placeholder" />}
				{previewImage ? (
					<img src={file} alt={`Post`} className={`h-80 w-full rounded-b-2xl object-cover`} />
				) : (
					<Swiper ref={swiperRef} className={`${selectedContentType ? '' : 'p-2'} transition-all`} slidesPerView={1} pagination={{ clickable: true }} modules={[Pagination]}>
						<SwiperSlide>
							<div className={`relative`}>{type === 'image' ? <img src={dataType === 'image' ? URL.createObjectURL(file) : `/images/campaigns/${file}`} alt={`Post`} className={`h-96 w-full rounded-b-2xl object-cover`} /> : <video src={URL.createObjectURL(file)} className="h-64 w-full object-cover" controls />}</div>
						</SwiperSlide>
					</Swiper>
				)}
			</div>
		</Box>
	);
};

export default InstagramSerialStory;
